<template>
  <div>
    <toast
      v-if="showToast"
      class="mt-2"
      type="success-filled"
      description="Exclusión guardada correctamente"
      @timeout="handleCloseToast"
      @close="handleCloseToast"
    />

    <card>
      <template #content>
        <b-row>
          <b-col>
            <h4>{{ title }}</h4>
          </b-col>
          <b-col v-if="!isLab() && !isCoop()" class="text-right">
            <b-button variant="primary" @click="crear">{{
              $t('button.create')
            }}</b-button>
          </b-col>
        </b-row>
      </template>
      <template>
        <div v-if="items.length">
          <DataTableNaf
            :fields="columns"
            :items="items"
            :per-page="10"
            grid-cols="2fr 2fr 2fr 2fr 2fr 2fr"
          >
            <template #cell(nombre)="{ item }">
              <span>{{ item.nombre }}</span>
            </template>
            <template #cell(icono)="{ item }">
              <span>{{ item.icono }}</span>
            </template>
            <template #cell(ruta)="{ item }">
              <span>{{ item.ruta }}</span>
            </template>
            <template #cell(orden)="{ item }">
              <span>{{ item.orden }}</span>
            </template>
            <template #cell(visible)="{ item }">
              <span
                v-if="item.visible"
                class="icon icon-checkmark-outline"
              ></span>
              <span v-else></span>
            </template>
            <template #cell(icons)="{ item }">
              <div class="d-flex justify-content-between">
                <div class="pr-2">
                  <span
                    class="icon icon-edit-outline"
                    @click="editar(item)"
                  ></span>
                </div>
                <div v-if="!isLab() && !isCoop()">
                  <span
                    class="icon icon-trash-outline"
                    @click="openConfirmacion(item.id)"
                  ></span>
                </div>
              </div>
            </template>
          </DataTableNaf>
        </div>
        <card-item-simple v-if="!items.length">
          <template #description>
            <div>{{ $t('sinResultados') }}</div>
          </template>
        </card-item-simple>
      </template>
    </card>
    <modal-menu
      v-if="showModal"
      :item="texto"
      :es-nuevo="esNuevo"
      @close="close"
      @save="loadItems"
    />
    <modal-confirmacion
      v-if="showConfirmation"
      @close="close"
      @confirm="borrar"
    />
  </div>
</template>

<script>
import menu from '@/api/menu.api';
import ModalMenu from './ModalMenu.vue';
import colors from '@/mixins/colors.js';
import { mapGetters } from 'vuex';
export default {
  name: 'ListadoMenu',
  components: {
    ModalMenu,
  },
  extends: menu,
  mixins: [colors],
  data() {
    return {
      title: 'Menu',
      showModal: false,
      showConfirmation: false,
      showResetPassword: false,
      items: [],
      esNuevo: false,
      texto: {},
      showToast: false,
      columns: [
        {
          key: 'nombre',
          sortable: true,
          label: 'Nombre',
        },
        {
          key: 'icono',
          sortable: true,
          label: 'Icono',
        },
        {
          key: 'ruta',
          sortable: true,
          label: 'Ruta',
          class: 'justify-content-center',
        },
        {
          key: 'orden',
          sortable: true,
          label: 'Orden',
          class: 'justify-content-center',
        },
        {
          key: 'visible',
          sortable: true,
          label: 'Visible',
          class: 'justify-content-center',
        },
        {
          key: 'icons',
          sortable: false,
          label: '',
          class: 'justify-content-end',
        },
      ],
      request: {},
      loading: true,
      itemToDelete: null,
      userSelected: {},
    };
  },
  watch: {
    request: function () {
      this.loadItems();
    },
    reload: function () {
      this.loadItems();
    },
  },
  created() {
    this.loadItems();
  },
  methods: {
    ...mapGetters(['isCoop', 'isLab']),
    loadItems: function () {
      let loadPromise = new Promise((resolve) => {
        this.getAllMenu(resolve, this.request);
      });
      loadPromise.then((data) => {
        this.items = [];
        this.items = data;
      });
    },
    editar: function (item) {
      this.esNuevo = false;
      this.texto = {
        ...item,
      };
      this.showModal = true;
    },
    crear: function () {
      this.esNuevo = true;
      this.texto = {};
      this.showModal = true;
    },
    borrar: function () {
      this.showConfirmation = false;
      if (this.itemToDelete) {
        let request = {
          id: this.itemToDelete,
        };
        let deletePromise = new Promise((resolve) => {
          this.deleteMenu(resolve, request);
        });
        deletePromise.then(() => {
          this.loadItems();
        });
      }
    },
    close: function () {
      this.showConfirmation = false;
      this.showModal = false;
      this.showResetPassword = false;
    },
    openConfirmacion: function (data) {
      this.itemToDelete = data;
      this.showConfirmation = true;
    },
    openResetPassword: function (data) {
      console.log(data);
      this.showResetPassword = true;
      this.userSelected = data;
    },
    handleCloseToast() {
      this.showToast = false;
    },
  },
};
</script>

<style lang="scss" scope></style>
